import { warn } from "../../logging/warn";
import { error } from "../../logging/error";
import { getQualifiedClassName } from "@goodgamestudios/createjs-utilities";

/**
 * Created with IntelliJ IDEA.
 * User: npuschke
 * Date: 10.12.12
 * Time: 17:35
 * „Look on my works, ye Mighty, and despair!“
 */

const instantiationSecret: number = Math.random();

export class BasicEnum {

    // Dictionary of all enumerated values for all subclasses
    private static _basicValues: Map<any, any> = new Map<any, any>();

    // secret value that is needed in the constructor and prevents the instantiation of enums outside of their classes
    protected static instantiationKey: number = instantiationSecret;

    // instance variables
    private _name: string;

    // getter for instance variables
    public get name(): string {
        return this._name;
    }

    /**
     * Basic enum class from which custom enums can be derived from.
     *
     * <p>
     *     Do not instantiate, this is an abstract class!
     * </p>
     *
     * For correct usage, have a look at some of its subclasses.
     *
     * @param name
     * @param doNotInstantiate
     */
    constructor(name: string, doNotInstantiate: number) {
        if (doNotInstantiate !== BasicEnum.instantiationKey) {
            this.throwInstantiationError();
        }

        this._name = name;

        // save in value list for its enum type
        let enumClass: Object = Object(this).constructor;

        if (BasicEnum._basicValues.get(enumClass) == null) {
            BasicEnum._basicValues.set(enumClass, []);
        }

        BasicEnum._basicValues.get(enumClass).push(this);
    }

    /**
     * Standard method to get a certain enum value by one of its properties, to implement property-specific methods in custom enums.
     * @param enumType
     * @param propertyName
     * @param propertyValue
     * @param valueNone
     * @return
     */
    protected static getByProperty(enumType: Object, propertyName: string, propertyValue: any, valueNone: BasicEnum): BasicEnum {
        let returnValue: BasicEnum = valueNone;

        let values: BasicEnum[] = BasicEnum._basicValues.get(enumType);

        if (values != null) {
            for (let value of values) {
                if (value[propertyName] === propertyValue) {
                    returnValue = value;
                    break;
                }
            }
        }

        return returnValue;
    }

    public toString(): string {
        return this.getClassName() + "." + this._name;
    }

    protected getClassName(): string {
        return getQualifiedClassName(this);
    }

    protected throwInstantiationError(): void {
        error("Only instantiate " + this.getClassName() + " within itself!");
        //throw new Error("Only instantiate " + this.getClassName() + " within itself!");
    }
}

export let instantiationKey: number = instantiationSecret;